import { Survey } from 'apis/Surveys/types'
import I18n from 'translations/i18n'

export const noApprovalCycleDetails = [
  {
    icon: 'magic-wand-02',
    title: 'label.efficiency',
    description: 'description.hr_efficiency',
  },
  {
    icon: 'file-check-01',
    title: 'label.increase_aacuracy',
    description: 'description.empower_data_completion',
  },
  {
    icon: 'face-happy',
    title: 'label.employee_experience',
    description: 'description.onboarding_optimization',
  },
]

export const surveyStatusColorMapping: {
  [key: string]: 'primary' | 'yellow' | 'green' | 'gray' | undefined
} = {
  active: 'primary',
  closed: 'yellow',
  scheduled: 'green',
  draft: 'gray',
}

export const trackingOptions = (
  item: Survey,
): Array<{
  text: string
  leadingIcon: string
  value: string
  testId: string
  destructive?: boolean
}> => {
  return [
    ...(item.status === 'draft' || item.status === 'scheduled'
      ? [
          {
            text: I18n.t('label.edit'),
            leadingIcon: 'edit-02',
            value: 'editSurvey',
            testId: 'edit_survey',
          },
        ]
      : []),
    ...(item.status === 'active'
      ? [
          {
            text: I18n.t('label.send_reminder'),
            leadingIcon: 'bell-ringing-04',
            value: 'sendReminderSurvey',
            testId: 'send_reminder_survey',
          },
        ]
      : []),
    {
      text: I18n.t('label.duplicate_as_draft'),
      leadingIcon: 'copy-03',
      value: 'duplicateAsDraft',
      testId: 'duplicate_as_draft',
    },
    {
      text: I18n.t('label.delete'),
      leadingIcon: 'trash-01',
      value: 'deleteSurvey',
      testId: 'delete_survey',
      destructive: true,
    },
    ...(item.status === 'active'
      ? [
          {
            text: I18n.t('label.close_survey'),
            leadingIcon: 'file-lock-02',
            value: 'closeSurvey',
            testId: 'close_survey',
          },
        ]
      : []),
  ]
}

export const NPS_SCORE = [
  { value: 0 },
  { value: 1 },
  { value: 2 },
  { value: 3 },
  { value: 4 },
  { value: 5 },
  { value: 6 },
  { value: 7 },
  { value: 8 },
  { value: 9 },
  { value: 10 },
]

export const EMOJIS = [
  { emoji: '😠', value: 'strongly_disagree', label: 'label.survey_strongly_disagree' },
  { emoji: '😞', value: 'disagree', label: 'label.survey_disagree' },
  { emoji: '😐', value: 'neutral', label: 'label.survey_neutral' },
  { emoji: '😊', value: 'agree', label: 'label.survey_agree' },
  { emoji: '😍', value: 'strongly_agree', label: 'label.survey_strongly_agree' },
]

export const SucessImageIllustation =
  'https://staticfiles.jisr.net/static-files-main/assets/jisr/images/Success-illustration.png'
